module.exports = __webpack_public_path__ + "img/16_64.fb980160.png";